<template>
  <div class="compound public-content" ref="templateWrapper">
    <div class="breadcrumb">模板管理</div>
    <div class="add-category">
      <el-form :inline="true" :model="vo" class="demo-form-inline">
        <el-form-item label="模板名称">
          <el-input v-model="vo.name" placeholder="请输入模板名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="模板主题">
          <el-select style="margin:0 10px;" v-model="vo.themeId" clearable placeholder="请选择">
            <el-option v-for="item in themeList" :key="item.themeId" :label="item.themeName" :value="item.themeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否关联尺寸组">
          <el-select style="margin:0 10px;" v-model="vo.isAssociatedeSizeGroup" clearable placeholder="请选择">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="尺寸组" v-show="vo.isAssociatedeSizeGroup">
          <el-select clearable v-model="vo.composeSizeGroupId" :filter-method="getSizeGroupList" filterable placeholder="请输入尺寸组查询">
            <el-option v-for="item in sizeGroupList" :key="item.id" :label="item.groupName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板类型" v-show="vo.isAssociatedeSizeGroup">
          <el-select style="margin:0 10px;" v-model="vo.templateType" clearable placeholder="请选择">
            <el-option v-for="(k, v) in $config.templateType" :key="k" :label="k" :value="v"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float:right;">
          <el-button round @click="queryInfo.pageNum = 1, onSubmit()">查询</el-button>
          <el-button round type="primary" @click="newBuilt()">新建模板</el-button>
          <el-button round type="primary" @click="theme()">模板主题</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border>
          <el-table-column label="模板名称" prop="name"></el-table-column>
          <el-table-column label="模板页" prop="moduleNameStr"></el-table-column>
          <el-table-column label="模板主题" prop="themeName"></el-table-column>
          <el-table-column label="模板性质" prop="attribute">
            <template slot-scope="scope"> {{ scope.row.attribute === 1 ? '半批' : scope.row.attribute === 2 ? '整批' : '' }} </template>
          </el-table-column>
          <el-table-column label="是否关联尺寸组" prop="isAssociatedeSizeGroup">
            <template slot-scope="scope"> {{ scope.row.isAssociatedeSizeGroup ? '是' : '否' }} </template>
          </el-table-column>
          <el-table-column label="尺寸组" prop="composeSizeGroup.groupName">
            <template slot-scope="scope">
              <span class="color-blue" @click="getSizeGroupMsg(scope.row.composeSizeGroup.composeSizeGroupId), dialogVisible = true">{{ scope.row.composeSizeGroup ? scope.row.composeSizeGroup.groupName
                : '' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="模板类型" prop="themeName">
            <template slot-scope="scope"> {{ $config.templateType[scope.row.templateType] }} </template>
          </el-table-column>
          <el-table-column label="默认">
            <template slot-scope="scope">
              <span v-show="scope.row.pickDefault">默认选片模板<br></span>
              <span v-show="!scope.row.pickDefault && scope.row.templateModuleXrefs.length === 1 && !scope.row.isAssociatedeSizeGroup" class="color-blue"
                @click="setDefult('Pick', scope)">设为默认选片模板<br></span>
              <span v-show="scope.row.collDefault">默认收片模板<br></span>
              <span v-show="!scope.row.collDefault && scope.row.templateModuleXrefs.length === 1 && !scope.row.isAssociatedeSizeGroup" class="color-blue"
                @click="setDefult('Coll', scope)">设为默认收片模板</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color-blue" @click="newBuilt(scope.row)">编辑<br></span>
              <!-- <span class="color-blue" @click="$refs.setExample.show(scope.row.templateId,true)">上传示例<br></span> -->
              <span class="color-blue" @click="$refs.setExample.show(scope.row.templateId, false)">查看示例<br></span>
              <span class="color-blue" @click="deleteId = scope.row.templateId, del(scope.row.templateId)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="信息提示" :visible.sync="tipDialog" width="500px">
      <div class="data-list">
        <el-table :data="tipTableData" border>
          <el-table-column label="产品名称" prop="spuName"></el-table-column>
          <el-table-column label="sku名称" prop="skuName"></el-table-column>
        </el-table>
      </div>
      <span style="color:red">请先取消关联，再删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="500px">
      <span>确认删除该模板？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteTemplate(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="尺寸组" :visible.sync="dialogVisible" width="70%">
      <el-table :data="[sizeGroupMsg]" border>
        <el-table-column type="expand">
          <template v-slot='scope'>
            <div style="width:100%;height:100%;background:red">
              <el-table :data="scope.row.sizeList" border>
                <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                <el-table-column label="页面类型" prop="typeName">
                  <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
                </el-table-column>
                <el-table-column label="页面名称" prop="pageName"></el-table-column>
                <el-table-column label="宽高">
                  <template slot-scope="scope"> {{ scope.row.sizeWidth }}*{{ scope.row.sizeHeight }}mm </template>
                </el-table-column>
                <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                <el-table-column label="出血" width="220px">
                  <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{ scope.row.bleed.bleedRight }}mm
                    <br> 内侧：{{ scope.row.bleed.bleedIn }}mm </template>
                </el-table-column>
                <el-table-column label="码">
                  <template slot-scope="scope">
                    <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="尺寸组名称" prop="groupName"></el-table-column>
        <el-table-column label="尺寸组类" prop="composeSizeGroupCategory.categoryName"></el-table-column>
        <el-table-column label="页面名称" prop="pageName">
          <template slot-scope="scope"> {{ scope.row.pageName.substring(0, scope.row.pageName.length - 1) }} </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <setExample ref="setExample" />
  </div>
</template>
<script>
import setExample from './setExample.vue'
import VPagination from '@/components/Pagination/index'
import { templatePage, themeList, templateDel, templateSetCollDefault, templateSetPickDefault } from '@/api/auxx.js'
import { groupListPageing, getSkuByTemplateId, composeGroupDetail } from '@/api/pms.js'
export default {
  name: 'compound',
  components: {
    VPagination, setExample
  },
  data () {
    return {
      dialogVisible: false,
      deleteDialog: false,
      tipDialog: false,
      deleteId: '',
      themeList: [],
      vo: {
        isAssociatedeSizeGroup: '',
        name: '',
        templateId: '',
        templateType: '',
        composeSizeGroupId: '',
        attribute: ''
      },
      roleDialog: false,
      composeList: [],
      keywords: '',
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      compoundType: [],
      tableData: [],
      sizeGroupList: [],
      tipTableData: [],
      rememberScroll: null
    }
  },
  async created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.vo = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('offsetY')
    }
    await this.onSubmit()
    await this.getThemeList()
    this.$nextTick(() => {
      let that = this
      that.$refs.templateWrapper.addEventListener('scroll', that.handleScroll)
      // 根据本地缓存取出初始值并渲染页面
      that.rememberScroll = Number(sessionStorage.getItem('offsetY'))
      that.$refs.templateWrapper.scrollTo(0, that.rememberScroll)
    })
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
    if (this.rememberScroll) {
      sessionStorage.setItem('offsetY', this.rememberScroll)
      // console.log('rememberScroll=', this.rememberScroll)
    } else {
      sessionStorage.setItem('offsetY', 0)
    }
  },
  methods: {
    handleScroll (e) { // vue 方法中可直接加e获取event，当@click方法不加括号默认传event参数。      
      const target = e.target // 获取元素目标
      if (target) {
        this.rememberScroll = target.scrollTop// 获取离页面上方高度
        // console.log(this.rememberScroll, 'handleScroll')
      } else {
        this.rememberScroll = 0
      }
    },
    getSizeGroupList (val) {
      if (!val) {
        return
      }
      groupListPageing({
        pageNum: 1,
        pageSize: 1000,
        data: {
          groupName: val
        }
      })
        .then(res => {
          if (res.data.success) {
            this.sizeGroupList = res.data.data.records
          }
        })
    },
    setDefult (type, scope) {
      if (type === 'Coll') {
        templateSetCollDefault(scope.row.templateId)
          .then(res => {
            if (res.data.success) {
              this.$message.success('设置成功')
              this.onSubmit()
            }
          })
      } else {
        templateSetPickDefault(scope.row.templateId)
          .then(res => {
            if (res.data.success) {
              this.$message.success('设置成功')
              this.onSubmit()
            }
          })
      }
    },
    del (templateId) {
      // 查看是否存在关联信息
      console.log(templateId)
      getSkuByTemplateId(templateId).then(res => {
        if (!res.data.exist) {
          // 不存在时打开确认删除对话框
          this.deleteDialog = true
        } else {
          // 存在时打开信息提示对话框
          this.tipDialog = true
          this.tipTableData = res.data.skuList
        }
      })
    },
    deleteTemplate (id) {
      templateDel(id)
        .then(res => {
          if (res.data.success) {
            this.$message.success('删除成功')
            this.deleteDialog = false
            this.onSubmit()
          }
        })
    },
    // 获取尺寸组详细信息
    getSizeGroupMsg (id) {
      composeGroupDetail(id).then(res => {
        if (res.data.success) {
          this.sizeGroupMsg = res.data.data
        }
      })
    },
    async getThemeList () {
      await themeList()
        .then(res => {
          if (res.data.success) {
            this.themeList = res.data.data
          }
        })
    },
    changeRole () {
      this.roleDialog = true
    },
    async onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.vo))
      }
      await templatePage({
        params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize },
        vo: this.vo
      })
        .then(res => {
          if (res.data.success) {
            let list = res.data.data.content
            list.forEach(item => {
              let str = []
              item.templateModuleXrefs.forEach(module => {
                str.push(module.module.name)
              })
              item.moduleNameStr = str.join(', ')
            })
            this.tableData = list
            this.queryInfo.total = res.data.data.total
          }
        })
    },
    // 新建
    newBuilt (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.vo))
      if (!row) this.$router.push({ path: '/imageTemplate' })
      if (row) this.$router.push({ path: '/imageTemplate', query: { id: row.templateId } })
    },
    theme () {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.vo))
      this.$router.push('/ActiveTheme')
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
.compound {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  // overflow: auto;
  -webkit-overflow-scrolling: touch;

  // &::-webkit-scrollbar {
  //   display: none;
  // }
  .add-category {
    justify-content: space-between;
  }

  .keywords {
    display: flex;
    justify-content: space-around;
    // width: 750px;
    align-items: center;

    .el-input {
      width: 180px;
    }
  }
}
</style>
